import React from 'react';
import './index.css';
import logo from '../../Assets/logo.svg';

function TermsPage() {
  return (
    <>
      <div className="container">
        <img src={logo} alt="Logo AlgorithmX" className="logo" />
      </div>
    </>
  );
}

export default TermsPage;
